module.exports = __webpack_public_path__ + "static/img/ela-more-about-blast3.78c3397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/ela-more-about-blast3.jpg
// module id = Z5AF
// module chunks = 1